import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone, CrownOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { authService } from '../../services';
import logo from '../../assets/img/omecap-hub.png';
import './AdminLoginPage.css';

const AdminLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const response = await authService.loginAdmin(values);
      console.log('[DEBUG] (👉ﾟヮﾟ)👉  ~ onFinish  ~ response:', response)
      if (response.data.success) {
        // update access token in local storage
       
        const userResponse = await authService.getCurrentUser(response.data.data.access);
        if (userResponse.data.success) {
          // Chỉ cho phép admin đăng nhập
          if (userResponse.data.data.role !== 'admin') {
            message.error('Bạn không có quyền truy cập trang này!');
            setLoading(false);
            return;
          }
          login(userResponse.data.data, response.data.data.access, response.data.data.refresh);
          message.success('Đăng nhập thành công!');
          navigate('/admin/dashboard');
        }
      }
    } catch (error) {
      message.error('Tên đăng nhập hoặc mật khẩu không đúng!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-background">
        <Card className="admin-login-card">
          <div className="admin-login-header">
            <img src={logo} alt="Login Background" style={{ width: '200px', height: 'auto' }} />
            
          </div>
          <Form
            name="admin-login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Nhập tài khoản Admin"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Nhập mật khẩu"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                ĐĂNG NHẬP ADMIN
              </Button>
            </Form.Item>
          </Form>
          <div className="admin-login-footer">
            <Link to="/login" className="user-link">Đăng nhập phòng khám</Link>
            <p>Copyright Omecap © 2025</p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AdminLoginPage;
